import { Clock, Gift, Sparkles, Package } from "lucide-react";

export type AddonItem = {
  id: string;
  title: string;
  price: number;
  desc: string;
  icon: typeof Clock;
  link: string;
  badge?: string;
  badgeColor?: string;
  hasColor?: boolean;
};

export type PropertyItem = {
  id: string;
  name: string;
  code: string;
  image: string;
  // Bedroom count used by the Add-Ons property filter.
  // Values: "studio" | "1" | "2" | "3+"
  bedrooms: string;
};

export const addonsList: AddonItem[] = [
  {
    id: "early-1",
    title: "1 Hour Early Check-In",
    price: 20.0,
    desc: "Arrive at 3 PM instead of 4 PM.",
    icon: Clock,
    link: "https://api.rhinodistrict.com/payment-link/6a361629eaa0b5cf5db565f7",
    badge: "Requires 12hr Notice",
    badgeColor: "bg-secondary text-secondary-foreground",
  },
  {
    id: "early-2",
    title: "2 Hour Early Check-In",
    price: 27.0,
    desc: "Arrive at 2 PM instead of 4 PM.",
    icon: Clock,
    link: "https://api.rhinodistrict.com/payment-link/6a3615fbeaa0b5cf5db565f6",
    badge: "Requires 12hr Notice",
    badgeColor: "bg-secondary text-secondary-foreground",
  },
  {
    id: "late-1",
    title: "1 Hour Late Check-out",
    price: 20.0,
    desc: "Depart at 11 AM instead of 10 AM.",
    icon: Clock,
    link: "https://api.rhinodistrict.com/payment-link/6a360fcd71a0aa761e465b64",
    badge: "Requires 12hr Notice",
    badgeColor: "bg-secondary text-secondary-foreground",
  },
  {
    id: "late-2",
    title: "2 Hour Late Check-Out",
    price: 27.0,
    desc: "Depart at 12 PM instead of 10 AM.",
    icon: Clock,
    link: "https://api.rhinodistrict.com/payment-link/6a361d6eeaa0b5cf5db565fb",
    badge: "Requires 12hr Notice",
    badgeColor: "bg-secondary text-secondary-foreground",
  },
  {
    id: "combo",
    title: "2 Hour Early/Late Combo",
    price: 45.0,
    desc: "Check in at 2 PM, check out at 12 PM.",
    icon: Sparkles,
    link: "https://api.rhinodistrict.com/payment-link/6a3615b971a0aa761e465b6f",
    badge: "Most Popular",
    badgeColor: "bg-primary text-black",
  },
  {
    id: "birthday",
    title: "Birthday Surprise",
    price: 150.0,
    desc: "Sweet surprise, festive touch, and elegant florals.",
    hasColor: true,
    icon: Gift,
    link: "https://api.rhinodistrict.com/payment-link/6a36183beaa0b5cf5db565fa",
    badge: "Requires 48hr Notice",
    badgeColor: "bg-secondary text-secondary-foreground",
  },
  {
    id: "forgotten",
    title: "Return My Forgotten Item",
    price: 25.0,
    desc: "If found, we'll package and ship your item. Shipping costs are extra.",
    icon: Package,
    link: "https://api.rhinodistrict.com/payment-link/6a57c126a655fa0b802a470b",
    badge: "Plus Shipping",
    badgeColor: "bg-secondary text-secondary-foreground",
  },
];

export const propertiesList: PropertyItem[] = [
  {
    id: "930-1",
    name: "The Pink Retreat",
    code: "930 • 1",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d70b5835a584d30a09727.jpg",
  },
  {
    id: "930-2",
    name: "The Bauhaus Retreat",
    code: "930 • 2",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d71323d17d8ed0474a151.jpg",
  },
  {
    id: "930-3",
    name: "The Urban Nest Retreat",
    code: "930 • 3",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d730cdda1925ef55fad3d.jpg",
  },
  {
    id: "cozy",
    name: "The Cozy Retreat",
    code: "Cozy",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/690817efbee93b1c359788f7.jpeg",
  },
  {
    id: "blue",
    name: "The Blue Loft Retreat",
    code: "Blue Loft",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d71c686df4fac8ca86c6e.jpg",
  },
  {
    id: "hg",
    name: "The Hidden Gem Retreat",
    code: "Hidden Gem",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d71c6dda19272c55f9c50.jpg",
  },
  {
    id: "ss",
    name: "Sugar Skull Retreat",
    code: "Sugar Skull",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d730ccfb90c4086a582ca.jpg",
  },
  {
    id: "mono",
    name: "Monopoly Retreat",
    code: "Monopoly",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d730ce889d3e497603084.jpg",
  },
  {
    id: "mod",
    name: "The Modern Retreat",
    code: "Modern",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d730cb716f5322544e169.jpg",
  },
  {
    id: "willow",
    name: "The Willow Studio",
    code: "Willow",
    bedrooms: "studio",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d730d835a58702aa0b341.jpg",
  },
  {
    id: "country",
    name: "The Country Retreat",
    code: "Country",
    bedrooms: "1",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d730cdda192db1d5fad3e.jpg",
  },
  {
    id: "804",
    name: "The 804 Retreat",
    code: "804",
    bedrooms: "1",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d74b53d17d820ff74c988.jpg",
  },
  {
    id: "studio",
    name: "The StayAwhile Studio",
    code: "Studio",
    bedrooms: "studio",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d755f3d17d8822e74d543.jpg",
  },
  {
    id: "mass",
    name: "The Mass St Retreat",
    code: "Mass St",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d755f3d17d8174b74d542.jpeg",
  },
  {
    id: "adastra",
    name: "Ad Astra Studio",
    code: "Ad Astra",
    bedrooms: "studio",
    image:
      "https://assets.cdn.filesafe.space/7oQcAyw9kZpcBxPOtMLw/media/fe22396e-5483-45f9-a371-b4e451a5a522.jpeg",
  },
  {
    id: "redbrick",
    name: "Red Brick Retreat",
    code: "Red Brick",
    bedrooms: "3+",
    image:
      "https://assets.cdn.filesafe.space/7oQcAyw9kZpcBxPOtMLw/media/3110508f-28ca-4c98-8c7d-63e25346259d.png",
  },
  {
    id: "boho",
    name: "The Boho Hause Retreat",
    code: "Boho",
    bedrooms: "2",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d777fcfb90c00dfa5bb94.jpg",
  },
  {
    id: "zebra",
    name: "The Zebra Retreat",
    code: "Zebra",
    bedrooms: "3+",
    image:
      "https://storage.googleapis.com/msgsndr/7oQcAyw9kZpcBxPOtMLw/media/694d779ddda1924a995fe3b9.jpg",
  },
  {
    id: "bloom",
    name: "Bloom on Mass",
    code: "Bloom",
    bedrooms: "1",
    image:
      "https://assets.cdn.filesafe.space/7oQcAyw9kZpcBxPOtMLw/media/6a35770872754a77aa601ba9.png",
  },
  {
    id: "mercer",
    name: "The Mercer",
    code: "Mercer",
    bedrooms: "1",
    image:
      "https://assets.cdn.filesafe.space/7oQcAyw9kZpcBxPOtMLw/media/6a91b94d4fe74193543096d0.png",
  },
  {
    id: "barn",
    name: "The Barn Home",
    code: "Barn",
    bedrooms: "1",
    image:
      "https://assets.cdn.filesafe.space/7oQcAyw9kZpcBxPOtMLw/media/6a91b88148ca8386ebfdf875.png",
  },
  {
    id: "linden",
    name: "The Linden",
    code: "Linden",
    bedrooms: "1",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1762437762919918032/original/d75e2854-1d75-48a1-8985-c21568b3c872.png?im_w=720",
  },
  {
    id: "comfy-stay-rcp",
    name: "West Lawrence Retreat",
    code: "Comfy Stay",
    bedrooms: "2",
    image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1553796144123499495/original/9a6a15cd-21a3-480e-b11d-459838b07d50.png?im_w=720",
  },
];
